const ProtoframesTabs = document.querySelectorAll('.ProtoframesGrid-tab');
const ProtoframesTabDropdown = document.querySelector('.ProtoframesGrid-tabs .TabContainer-dropdown');
const ProtoframesBackgrounds = document.querySelectorAll('.ProtoframesBackground-slide');
if (ProtoframesTabs && ProtoframesTabs.length > 0) {
    function syncBackgrounds(index) {
        ProtoframesBackgrounds.forEach((background, i) => {
            background.classList.toggle('is-active', i === index);
        });
    }

    ProtoframesTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            syncBackgrounds(index);
        });
    });

    ProtoframesTabDropdown.addEventListener('change', () => {
        syncBackgrounds(parseInt(ProtoframesTabDropdown.value));
    });
}

const ProtoframesPlayButtons = document.querySelectorAll('.Protoframe-play');
if (ProtoframesPlayButtons && ProtoframesPlayButtons.length > 0) {
    ProtoframesPlayButtons.forEach((play) => {
        const VoiceLine = play.querySelector('audio');
        play.addEventListener('click', (e) => {
            e.stopPropagation();
            VoiceLine.play();
        });
    });
}
